/**
 * PPA $200 popup state machine — AS-IS port of the <script> block from
 * theme_live/sections/popup-email-capture.liquid (inventory #11).
 * Reads window.ppaPopupSettings, set inline by
 * sections/ppa-popup-email-capture.liquid, from the section's own settings.
 */
(function () {
  'use strict';

  var popup = document.querySelector('[data-popup]');
  if (!popup) return;

  // Shopify's bot challenge renders inside the theme, so the popup would sit
  // on top of the captcha and make it impossible to complete. Stay hidden.
  if (window.location.pathname.indexOf('/challenge') === 0) return;

  var config = window.ppaPopupSettings || {};

  var SETTINGS = {
    delay: (config.delaySeconds || 0) * 1000,
    suppressDays: config.suppressDays || 7,
    testMode: !!config.testMode,
    tags: config.tags || 'newsletter,popup-200',
    storageKey: 'ppa_popup_dismissed_until'
  };

  var card = popup.querySelector('[data-popup-card]');
  var body = popup.querySelector('.ppa-popup__body');
  var form = popup.querySelector('.ppa-popup__email-form');
  var input = popup.querySelector('.ppa-popup__email-input');
  var button = popup.querySelector('.ppa-popup__email-submit');
  var error = popup.querySelector('[data-popup-error]');

  var buttonLabel = button ? button.textContent : '';
  var lastFocused = null;

  /* ---------- Show once, then remember ---------- */

  function isSuppressed() {
    if (SETTINGS.testMode) return false;
    try {
      var until = window.localStorage.getItem(SETTINGS.storageKey);
      return !!until && Date.now() < parseInt(until, 10);
    } catch (e) {
      return false;
    }
  }

  function suppress() {
    if (SETTINGS.testMode) return;
    try {
      var until = Date.now() + SETTINGS.suppressDays * 86400000;
      window.localStorage.setItem(SETTINGS.storageKey, String(until));
    } catch (e) {}
  }

  /* ---------- Open / close ---------- */

  function open() {
    if (!popup.hidden) return;
    lastFocused = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('ppa-popup-locked');
    if (input) input.focus({ preventScroll: true });
  }

  function close() {
    if (popup.hidden) return;
    popup.hidden = true;
    document.body.classList.remove('ppa-popup-locked');
    suppress();
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  // Click the dark overlay, not the card
  popup.addEventListener('click', function (e) {
    if (e.target === popup) close();
  });

  document.addEventListener('keydown', function (e) {
    if (popup.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var controls = Array.prototype.slice.call(popup.querySelectorAll('button,a[href],input,select,textarea,[tabindex="0"]')).filter(function (el) {
        return !el.disabled && el.getClientRects().length;
      });
      var first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Anything on the site with data-popup-open reopens it — the footer's
  // "artwork credit offer" link (inventory #9).
  document.querySelectorAll('[data-popup-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      if (card) card.setAttribute('data-state', 'form');
      open();
    });
  });

  /* ---------- Submit ---------- */

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function showError(message) {
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }

  function setLoading(on) {
    if (!button) return;
    button.disabled = on;
    button.textContent = on ? 'Sending...' : buttonLabel;
  }

  /* The form submits at page level. The only job here is to validate before
     letting it go, and to recognise the visitor coming back afterwards. */

  if (form) {
    form.addEventListener('submit', function (e) {
      var email = (input.value || '').trim();

      if (!EMAIL_RE.test(email)) {
        e.preventDefault();
        showError('Please enter a valid email address.');
        input.focus();
        return;
      }

      // The footer newsletter also returns with customer_posted=true; this
      // marks the signup as coming from the credit popup.
      try { sessionStorage.setItem('ppa_popup_submitted', '1'); } catch (err) {}

      // --- Send lead to HubSpot ---
      try {
        var HS_PORTAL = '247207659';
        var HS_FORM = '5d12000a-8413-4d21-9a1b-75b53bd7dbfc';

        var hutk = null;
        var m = document.cookie.match(/hubspotutk=([^;]+)/);
        if (m) { hutk = m[1]; }

        var payload = {
          fields: [
            { objectTypeId: '0-1', name: 'email', value: email }
          ],
          context: {
            pageUri: window.location.href,
            pageName: document.title
          }
        };
        if (hutk) { payload.context.hutk = hutk; }

        fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + HS_PORTAL + '/' + HS_FORM, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true
        });
      } catch (err) {
        // If HubSpot fails, don't block the Shopify subscription.
      }
      // --- end HubSpot ---

      // No preventDefault. The page navigates, Shopify may show a bot
      // challenge, and the visitor comes back with customer_posted set.
      if (error) error.hidden = true;
      setLoading(true);
    });

    if (input) {
      input.addEventListener('input', function () {
        if (error) error.hidden = true;
      });
    }
  }

  function showThanks() {
    if (card) card.setAttribute('data-state', 'thanks');
    if (body) body.scrollTop = 0;
    popup.hidden = false;
    document.body.classList.add('ppa-popup-locked');
  }

  /* ---------- Go ---------- */

  // Coming back from a successful signup. Shopify appends customer_posted,
  // true when it accepted the address, false when it did not.
  var posted = null;
  try {
    posted = new URLSearchParams(window.location.search).get('customer_posted');
  } catch (e) {}

  var fromPopup = false;
  try {
    fromPopup = sessionStorage.getItem('ppa_popup_submitted') === '1';
    sessionStorage.removeItem('ppa_popup_submitted');
  } catch (e) {}

  if (posted === 'true') {
    // Subscribed either way, so stop offering the popup; only a popup signup
    // is told its credit is on the way.
    suppress();
    if (fromPopup) showThanks();
    // Tidy the address bar so a refresh doesn't replay the thank you screen.
    if (window.history && window.history.replaceState) {
      var clean = window.location.pathname + window.location.hash;
      window.history.replaceState({}, '', clean);
    }
  } else if (posted === 'false' && fromPopup) {
    popup.hidden = false;
    document.body.classList.add('ppa-popup-locked');
    showError('That address could not be added. Please try again.');
  } else if (!isSuppressed()) {
    window.setTimeout(open, SETTINGS.delay);
  }
})();
